import { Observable, throwError } from "rxjs";

export const handleError = (error: any): Observable<never> => {
  let errorMsg: string;
  if (error.error instanceof ErrorEvent) {
    errorMsg = `Error: ${error.error.message}`;
  } else {
    switch (error.status) {
      case 404: {
        errorMsg = `Not Found: ${error.message}`;
      }
      case 403: {
        errorMsg = `Access Denied: ${error.message}`;
      }
      case 500: {
        errorMsg = `Internal Server Error: ${error.message}`;
      }
      default: {
        errorMsg = `Unknown Server Error: ${error.message}`;
      }
    }
  }
  return throwError(errorMsg);
};
